module.exports = __webpack_public_path__ + "8651e30f431f5a9198ac4d75ff4c26a1.svg";